<div class="pb-4 max-sm:pb-2">
  <div
    class="flex items-center w-full gap-5 px-10 text-white bg-top bg-scores h-238 rounded-10 max-sm:rounded-5 max-sm:h-81 max-sm:px-3 max-sm:gap-3"
  >
    <div
      class="w-[150px] h-[150px] p-4 max-sm:p-2 max-sm:w-[57px] max-sm:h-[57px] bg-white rounded-full flex justify-center items-center"
    >
      <img
        alt="country_logo"
        class="w-[105px] h-[105px] max-sm:w-[40px] max-sm:h-[40px] object-contain"
        [src]="getLogoTeam().logo || urlIMG + 'default.png'"
      />
    </div>
    <div class="flex items-center font-inter-600">
      <h1 class="mr-2 text-white text-32 max-sm:text-14">
        {{ getNameTeam() }}
      </h1>
      <img
        alt="fav"
        class="cursor-pointer max-sm:w-[15px]"
        [src]="urlSVG + (isFavorite() ? 'fav-red.svg' : 'fav-outlined.svg')"
        (click)="$event.stopPropagation(); onFavoriteTeam()"
      />
    </div>
  </div>
</div>
